import { AxiosInstance as ApiInstance } from 'axios'

class Perfil {
  API: ApiInstance
  constructor (api: ApiInstance) {
    this.API = api
  }

  async listar () {
    try {
      const { data } = await this.API.get('api/usuario/perfil')
      return data
    } catch (error) {
      throw new Error(JSON.stringify(error))
    }
  }
}

export default Perfil
